module.exports = __webpack_public_path__ + "img/background.32f66707.png";